import { put2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { PosCommonSettings } from "@/shared/utils/interfaces";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const usePosSettingsMutation = () => {
  const { t } = useTranslation();
  const branchId = useBranchId();

  const mutation = useMutation({
    mutationFn: ({ item_id, ...body }: PosCommonSettings) =>
      put2(
        `internal/secure/pos/v1/possetting/edit/records/${branchId}/${item_id}`,
        body,
      ),
    onSuccess: () => {
      toast.success(t("success.update"));
    },
  });
  return mutation;
};

export default usePosSettingsMutation;
